import OverlayDonate, { OverlayDonateProps } from "../components/OverlayDonate/OverlayDonate";
import { UIController } from "../controllers/ui.controller";

export const presentOverlayDonateFn = (UI: UIController, props?: OverlayDonateProps) => () => {
  UI.OVERLAY.present({
    component: <OverlayDonate {...props} />,
  })
}